module.exports = __webpack_public_path__ + "img/digital.933d0cf3.png";